import React, { useRef } from "react";
import { Icon } from "../../Elements";

const File: React.FC<FileInterface> = ({
    fileName,
    fileAddress,
    className,
    isLoading
}) => {
    const aElement = useRef<HTMLAnchorElement>(null);
    return <>
        <a href={fileAddress} download={fileName} target="_blank" className="hidden" ref={aElement}></a>
        <div className={`bg-disable px-2 py-1 rounded-xl flex justify-between items-center ${className}`}>
            <span className="text-xs">{fileName.split('.')[0].shortText(30)}</span>
            <Icon disabled={isLoading} className="bg-primary text-white rounded-full !w-12 !h-12" icon="rayteb-file" onClick={() => {
                aElement.current?.click()
            }} />
        </div>
    </>
}
export default File;